import { MutationKey, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AdditionalInfo, StateResponse } from '../../api/api';
import { apiInstance, useGlobalState, useGlobalStateUpdate } from './../global-state';

interface AdditionalInfoMutationOptions {
  mutationKey?: MutationKey;
}

export function useAdditionalInfoMutation(options: AdditionalInfoMutationOptions = {}) {
  const state = useGlobalState();
  const updateFn = useGlobalStateUpdate();

  const mutationFn = async (request: AdditionalInfo) => {
    const { data } = await apiInstance.v4.additionalInformationPatch(
      state.checkout_session_id,
      request
    );
    return data;
  };

  return useMutation<StateResponse, AxiosError, AdditionalInfo>({
    mutationFn,
    mutationKey: options.mutationKey || ['state'],
    onSuccess: data => {
      updateFn(data);
    },
  });
}
